import Tabs from "@/lib/components/Tabs";
import { useState } from "react";
import CreateVoiceActor from "./CreateVoiceActor";
import UpdateVoiceActor from "./UpdateVoiceActor";

const adminTabs = [
  { label: "Add voiceactor", value: "ADD_VOICEACTOR" as const },
  { label: "Update voiceactor", value: "UPDATE_VOICEACTOR" as const },
];

function AdminView() {
  const [currentTabValue, setCurrentTabValue] = useState<
    "ADD_VOICEACTOR" | "UPDATE_VOICEACTOR"
  >("ADD_VOICEACTOR");

  return (
    <div className="mx-auto h-full w-full max-w-lg pb-6">
      <Tabs
        currentTab={currentTabValue}
        onTabClicked={(tab) => {
          setCurrentTabValue(tab);
        }}
        options={adminTabs}
        renderCurrentTab={(tab) => {
          if (tab === "ADD_VOICEACTOR") {
            return <CreateVoiceActor />;
          }

          if (tab === "UPDATE_VOICEACTOR") {
            return <UpdateVoiceActor />;
          }

          return null;
        }}
        classNameOptions="mx-0"
      />
    </div>
  );
}

export default AdminView;
